import { apiRequest } from "../config/apiRequest";
import { BaseURL, S3Configs } from "../config/config";
import { _toastVariants, ORDER_STATUS } from "../Constant";
import { apiUrl } from "../endPoints/apiUrl";
import { showMessage } from "../toast/globalToast";

export const validateImageFileType = (formate) =>
    [
        'image/png',
        'image/jpg',
        'image/jpeg',
        'image/gif',
        'image/bmp',
        'image/svg',
        'image/svg+xml',
    ].includes(formate);

export const validateDocumentFileType = (formate) =>
    [
        'image/png',
        'image/jpg',
        'image/jpeg',
        'image/gif',
        'image/bmp',
        'image/svg',
        'image/svg+xml',
        'application/pdf'
    ].includes(formate);

const isString = (value) => typeof value === 'string';

export const getS3Url = (path) => { return S3Configs.BaseURL + path; }



export const getFileUrl = (file) => {
    try {
        return URL.createObjectURL(file);
    } catch (error) {
        return '';
    }
};

export const removeChars = (inputString) => {
    return inputString.replace(/[^a-zA-Z0-9\s]/g, "");
};

export const handleFilePreviewSrc = (file) => {
    let url = '';
    let fileExtension = '';
    if (isString(file)) {
        url = getS3Url(file);
        fileExtension = url?.split('.').at(-1);
    } else {
        url = getFileUrl(file);
        fileExtension = file?.name?.split('.').at(-1);
    }
    return fileExtension;
};

export const uploadFile = async (file, dir) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        const res = await apiRequest({
            endUrl: apiUrl.uploadFile(dir),
            method: 'POST',
            headerType: "form",
            body: formData,
        });
        if (res.status) {
            return res.data.shortUrl;
        } else {
            throw new Error(res.message || "File upload failed");
        }
    } catch (error) {
        console.error("File upload error:", error);
    }

}

export const formatFileURL = (shortURL) => {
    if (typeof shortURL !== 'string' && shortURL) {
        return shortURL;
    }
    return `${BaseURL}/v1/file/${shortURL}`
}

export const handleCopy = async ({ text, message }) => {
    try {
        await navigator.clipboard.writeText(text);
        showMessage({ message: ` ${message} copied!`, variant: _toastVariants.Success });
    } catch (err) {
        showMessage({ message: 'Failed to copy text:', variant: _toastVariants.Error });
    }
};

export const getOrderStatus = (currStatus) =>{
    if (currStatus === ORDER_STATUS.CONFIRMED){
        return [ORDER_STATUS.PHOTO_CAPTURE, ORDER_STATUS.READY_FOR_PICKUP, ORDER_STATUS.PICKUP]
    }
    else if (currStatus === ORDER_STATUS.PHOTO_CAPTURE){
        return [ORDER_STATUS.READY_FOR_PICKUP, ORDER_STATUS.PICKUP]
    }
    else if (currStatus === ORDER_STATUS.READY_FOR_PICKUP){
        return [ORDER_STATUS.PICKUP]
    }
    return []
}